// extracted by mini-css-extract-plugin
export var content = "DashboardModuleBlock-module--content--9EgRw";
export var column = "DashboardModuleBlock-module--column--QrcI0";
export var reverse = "DashboardModuleBlock-module--reverse--utu9e";